// extracted by mini-css-extract-plugin
export const wrapper = "JoinInsta-module--wrapper--3WO47";
export const title = "JoinInsta-module--title--2gIag";
export const container = "JoinInsta-module--container--3rDUO";
export const image = "JoinInsta-module--image--3ZHDs";